import { Link } from 'react-router-dom';

const ServicesHero = () => {
  return (
    <section className="relative h-screen min-h-[700px] flex items-center justify-center overflow-hidden">
      <img
        src="https://public.readdy.ai/ai/img_res/34d518fba71106e3fed87dd23c5ed169.jpg"
        alt="Custom tailoring services at Custom Clothiers Wellesley MA"
        className="absolute inset-0 w-full h-full object-cover object-center"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/65 via-black/50 to-black/80"></div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <div>
            <div className="inline-flex items-center bg-white/10 backdrop-blur-sm border border-[#C4A962]/50 rounded-full px-6 py-2.5 mb-8">
              <i className="ri-scissors-line text-[#C4A962] mr-2 text-sm"></i>
              <span className="text-white text-sm font-medium tracking-widest uppercase">Bespoke Tailoring &amp; Custom Clothing</span>
            </div>

            <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold text-white mb-6 leading-none tracking-tight">
              Custom Tailoring<br />
              <span className="text-[#C4A962]">Built Around</span><br />
              <span className="text-white">You</span>
            </h1>
            <p className="text-xl text-gray-200 mb-10 leading-relaxed max-w-xl">
              From bespoke suits to custom shirts, wedding formalwear, and expert alterations —
              every garment crafted to your exact measurements. Serving Massachusetts since 1970.
            </p>

            <div className="flex flex-col sm:flex-row gap-4">
              <Link
                to="/contact"
                className="bg-[#C4A962] text-white px-9 py-4 rounded-lg text-lg font-semibold hover:bg-[#B39952] transition-all transform hover:scale-105 whitespace-nowrap text-center"
              >
                <i className="ri-calendar-line mr-2"></i>Book a Consultation
              </Link>
              <a
                href="tel:781-237-3166"
                className="bg-white/10 backdrop-blur-sm border border-white/30 text-white px-9 py-4 rounded-lg text-lg font-semibold hover:bg-white/20 transition-all whitespace-nowrap text-center"
              >
                <i className="ri-phone-line mr-2"></i>781-237-3166
              </a>
            </div>
          </div>

          <div className="hidden lg:block">
            <div className="grid grid-cols-2 gap-4">
              {[
                { icon: 'ri-ruler-line', num: '30+', label: 'Precision Measurements', sub: 'Per garment' },
                { icon: 'ri-palette-line', num: '5,000+', label: 'Premium Fabrics', sub: 'Italian, English & more' },
                { icon: 'ri-award-line', num: '55+', label: 'Years of Expertise', sub: 'Est. Wellesley 1970' },
                { icon: 'ri-star-fill', num: '4.9★', label: 'Client Rating', sub: '127+ Five-star reviews' },
              ].map((stat) => (
                <div key={stat.label} className="bg-white/8 backdrop-blur-sm border border-white/15 rounded-2xl p-6 text-center hover:border-[#C4A962]/40 transition-all">
                  <div className="w-12 h-12 flex items-center justify-center mx-auto mb-3 bg-[#C4A962]/20 rounded-xl">
                    <i className={`${stat.icon} text-[#C4A962] text-2xl`}></i>
                  </div>
                  <p className="text-white font-bold text-2xl leading-none">{stat.num}</p>
                  <p className="text-white text-xs font-semibold mt-1.5 leading-tight">{stat.label}</p>
                  <p className="text-gray-400 text-xs mt-0.5">{stat.sub}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 animate-bounce hidden md:block">
        <div className="w-8 h-8 flex items-center justify-center border border-white/30 rounded-full">
          <i className="ri-arrow-down-line text-white text-sm"></i>
        </div>
      </div>
    </section>
  );
};

export default ServicesHero;
